module.exports = __webpack_public_path__ + "img/sld_star_delta_transformer_dark.b9913e0a.svg";